// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
    ITEM: '[data-fragment="FacultySelect.input"]',
    LABEL: '[data-fragment="FacultySelect.label"]'
};

export default class FacultySelect extends WebComponent {
    didMount() {
        const self = this;
        this.inputs = this.element.querySelectorAll(fragments.ITEM);
        this.labels = this.element.querySelectorAll(fragments.LABEL);
        this.labels.forEach(function(label) {
            label.addEventListener('click', function(e) {
                e.preventDefault();
                const value = this.dataset.value;
                const inputElement = self.element.querySelector('input[data-value="'+value+'"]');
                if (!inputElement.checked) {
                    self.inputs.forEach(function(input) {
                        input.checked = false;
                    });
                }
                inputElement.click();
            })
        });
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FacultySelect.js